__turbopack_context__.v({
  "cardContainer": "serviceCardsCard-module-scss-module__udT-tG__cardContainer",
  "cardDescription": "serviceCardsCard-module-scss-module__udT-tG__cardDescription",
  "cardTitle": "serviceCardsCard-module-scss-module__udT-tG__cardTitle",
  "cardWrapper": "serviceCardsCard-module-scss-module__udT-tG__cardWrapper",
});
